export default "//cloud.imgsmail.ru/cloud.mail.ru/187531/img/build/aside-promo-modal/default-quota-16.jpg";